import React from "react";
import {
  Box,
  SimpleGrid,
  Image,
  Text,
  Heading,
  Button,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { mainColor } from "./MainPage";

const services = [
  {
    title: "Wobble fiók szolgáltatóknak",
    description:
      "Szolgáltatóknak szóló online időpontfoglaló rendszer, amely egyszerűvé és gyorssá teszi a foglalások kezelését, valamint az online megjelenést.",
    image: "/assets/mockup_massage.png",
    buttonText: "Szolgáltatóként kezdés",
    onCtaHref: "https://app.wobble.hu/signup_page",
  },
  {
    title: "MyWobble ügyfélfiók",
    description:
      "Ügyfeleidnek készült fiók, ahol egy helyen kezelhetik minden foglalásukat, és könnyedén újra tudnak foglalni hozzád.",
    image: "/assets/blog/mywobble/mywobble6.png",
    buttonText: "Ügyfélfiók",
    onCtaHref: "https://app.wobble.hu/mywobble",
  },
];

const youtubeData = {
  link: "https://www.youtube.com/@WobbleAppHun",
  image: "/assets/youtube.png",
  text: "Nézd a YouTube-on",
};

const MyWobbleSection: React.FC = () => {
  return (
    <Box
      position="relative"
      bg="whiteAlpha.50"
      overflow="hidden"
      py={{ base: 16, md: 24 }}
      px={{ base: 4, md: 16 }}
    >
      {/* Blur színfolt */}
      <Box
        position="absolute"
        top="10%"
        right="5%"
        w="320px"
        h="320px"
        bgGradient="radial(circle at 30% 30%, rgba(0, 113, 136, 1), transparent 30%)"
        filter="blur(30px)"
        pointerEvents="none"
        zIndex={0}
      />

      {/* Alul ferde színátmenetes csík */}
      <Box
        position="absolute"
        bottom="0"
        left="0"
        width="100%"
        height={{ base: "150px", md: "200px" }}
        bgGradient="linear(to-r, #007188, teal.400)"
        clipPath="polygon(0 30%, 100% 0, 100% 100%, 0% 100%)"
        zIndex={0}
      />

      {/* Kártyák */}
      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={8}
        position="relative"
        zIndex={1}
      >
        {services.map((service) => (
          <VStack
            key={service.title}
            bg="white"
            border="1px solid #E2E8F0"
            borderRadius="2xl"
            p={{ base: 6, md: 10 }}
            spacing={6}
            textAlign="center"
            transition="transform 0.3s, box-shadow 0.3s"
            _hover={{
              transform: "scale(1.03)",
              boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
            }}
          >
            <Image
              src={service.image}
              alt={service.title}
              borderRadius="xl"
              maxH={{ base: "250px", md: "300px" }}
              objectFit="cover"
              mx="auto"
            />
            <Heading size="lg" color="#007188" fontStyle="italic">
              {service.title}
            </Heading>
            <Text fontSize="md" color="gray.700">
              {service.description}
            </Text>
            <Button
              colorScheme="teal"
              size="md"
              as="a"
              href={service.onCtaHref}
              target="_blank"
              rel="noopener noreferrer"
              textDecoration="none"
              _hover={{ bg: mainColor, textDecoration: "none" }}
            >
              {service.buttonText}
            </Button>
          </VStack>
        ))}
      </SimpleGrid>

      <HStack
        spacing={{ base: 4, md: 6 }}
        mt={12}
        justify="center"
        position="relative"
        zIndex={1}
        flexDirection={{ base: "column", md: "row" }}
      >
        <Image
          src={youtubeData.image}
          alt="YouTube"
          boxSize={{ base: "200px", md: "400px" }}
          borderRadius="md"
          objectFit="cover"
        />
        <Button
          as="a"
          href={youtubeData.link}
          target="_blank"
          rel="noopener noreferrer"
          textDecoration="none"
          _hover={{ bg: "red.600", textDecoration: "none" }}
          colorScheme="red"
          size={{ base: "md", md: "lg" }}
          w={{ base: "200px", md: "auto" }}
        >
          Nézd a YouTube-on
        </Button>
      </HStack>
    </Box>
  );
};

export default MyWobbleSection;
